'use client';

import Link from 'next/link';
import { Logo } from './Logo';

type FooterLinkItem = {
  label: string;
  href: string;
  icon?: boolean;
  pointer?: boolean;
};

type FooterSection = {
  title: string;
  links: FooterLinkItem[];
};

const footerLinks: FooterSection[] = [
  {
    title: "Usługi",
    links: [
      { label: "Strony WWW", href: "/uslugi/strony-www" },
      { label: "Optymalizacja SEO", href: "/uslugi/optymalizacja-seo" },
      { label: "Prospekting High Ticket", href: "/uslugi/prospekting-high-ticket" },
      { label: "Pakiet Tożsamości Cyfrowej", href: "/uslugi/pakiet-tozsamosci-cyfrowej" },
    ]
  },
  {
    title: "Nawigacja",
    links: [
      //{ label: "Portfolio", href: "/studia-przypadkow" },
      { label: "Blog", href: "/blog" },
      { label: "Kontakt", href: "/kontakt" },
    ]
  },
  {
    title: "Zasoby",
    links: [
      { label: "Dokumentacja", href: "/dokumentacja" },
      { label: "Polityka Prywatności", href: "/polityka-prywatnosci" },
      { label: "Regulamin", href: "/regulamin" },
    ]
  },
  {
    title: "Dane kontaktowe",
    links: [
      { label: "webpol63@wgmail.pl", href: "mailto:webpol63@wgmail.pl", icon: true },
      { label: "+48 690 800 452", href: "tel:+48690800452", icon: true },
      { label: "Wirtualne Biuro", href: "#", pointer: true },
      { label: "Cała Polska", href: "#", pointer: true },
    ]
  }
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative w-full bg-[#0b0c0e] border-t border-white/5 overflow-hidden font-sans">
      
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[150%] bg-orange-500/5 blur-[120px] rotate-12 opacity-40"></div>
          <div className="absolute top-[20%] right-[0%] w-[40%] h-[100%] bg-blue-600/5 blur-[120px] -rotate-12 opacity-40"></div>
          <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay"></div>
      </div>

      <div className="mx-auto max-w-[1250px] px-6 relative z-10">
        
        {/* HERO FOOTERA */}
        <div className="py-24 lg:py-36 flex flex-col lg:flex-row items-center lg:items-center justify-between gap-16 lg:gap-24 border-b border-white/5">
            <div className="relative w-full max-w-md lg:max-w-lg flex justify-center lg:justify-start">
                <div className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full flex items-center justify-center group">
                    <div className="absolute inset-0 rounded-full border border-white/10 bg-[#13151a]/50 backdrop-blur-sm shadow-2xl"></div>
                    <div className="absolute inset-0 rounded-full opacity-50 bg-gradient-to-tr from-orange-500/20 via-transparent to-blue-500/20 blur-xl group-hover:opacity-100 transition-opacity duration-700"></div>
                    <div className="relative w-40 h-40 lg:w-52 lg:h-52 rounded-full bg-[#0b0c0e] border border-white/5 flex items-center justify-center shadow-inner">
                         <div className="scale-[2.5] lg:scale-[3.0] opacity-80 grayscale group-hover:grayscale-0 group-hover:scale-[3.2] transition-all duration-500">
                            <Logo className="h-10 w-auto" />
                         </div>
                    </div>
                    <div className="absolute inset-0 rounded-full animate-[spin_10s_linear_infinite] opacity-20">
                        <div className="absolute top-0 left-1/2 w-[1px] h-1/2 bg-gradient-to-b from-blue-500 to-transparent"></div>
                    </div>
                </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
                <h2 className="text-4xl sm:text-5xl lg:text-7xl font-bold tracking-tight text-white leading-[1.1] mb-8">
                    Zbudujmy coś <br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-white">wielkiego.</span>
                </h2>
                {/* POPRAWKA: Zmiana text-gray-400 na text-gray-300 dla lepszego kontrastu */}
                <p className="text-gray-300 text-lg lg:text-xl max-w-xl mx-auto lg:mx-0 mb-12 leading-relaxed">
                    Odblokuj potencjał swojej firmy dzięki nowoczesnej stronie WWW i skutecznemu SEO. 
                    Pamiętaj, ta podróż dopiero się zaczyna.
                </p>
                
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                    <Link 
                        href="/kontakt"
                        className="relative inline-flex h-14 items-center justify-center overflow-hidden rounded-full bg-white px-10 font-medium text-neutral-950 transition-all duration-300 hover:bg-neutral-200 hover:scale-105 hover:ring-2 hover:ring-neutral-200 hover:ring-offset-2 hover:ring-offset-neutral-900 focus:outline-none focus:ring-2 focus:ring-neutral-200 focus:ring-offset-2 focus:ring-offset-neutral-900"
                    >
                        <span className="relative z-10 font-bold text-sm tracking-wide">DARMOWA WYCENA</span>
                        <div className="absolute inset-0 -z-10 bg-gradient-to-r from-orange-400 to-white opacity-0 transition-opacity duration-500 hover:opacity-10"></div>
                    </Link>

                    <Link 
                        href="mailto:kontakt@webpol.pl"
                        className="inline-flex h-14 items-center justify-center rounded-full border border-white/10 bg-white/5 px-10 font-medium text-white transition-all duration-300 hover:bg-white/10 hover:border-white/20 text-sm tracking-wide"
                    >
                        <span className="flex items-center gap-2">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                            NAPISZ DO NAS
                        </span>
                    </Link>
                </div>
            </div>
        </div>

        {/* LISTA LINKÓW */}
        <div className="py-16 border-t border-white/10">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-10 lg:gap-12">
                {footerLinks.map((column, idx) => (
                    <div key={idx} className="flex flex-col gap-6">
                        <h3 className="text-white font-bold text-lg">{column.title}</h3>
                        <ul className="flex flex-col gap-4">
                            {column.links.map((link, linkIdx) => (
                                <li key={linkIdx}>
                                    {/* POPRAWKA: Lepszy kontrast text-gray-400 -> text-gray-300 */}
                                    <Link 
                                        href={link.href} 
                                        className={`text-sm text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2 ${link.pointer ? 'pointer-events-none' : ''}`}
                                    >
                                        {link.icon && (
                                            <span className="text-blue-500/50">
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                                            </span>
                                        )}
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>

        {/* DOLNA BELKA */}
        <div className="border-t border-white/10 py-8 flex flex-col-reverse md:flex-row items-center justify-between gap-6 text-sm text-gray-500">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
                <span>&copy; {currentYear} Webpol Solutions.</span>
            </div>

            <div className="flex items-center gap-6">
                <div className="flex items-center gap-4">
                    {/* POPRAWKA: Dodano nazwy do linków (accessibility) */}
                    <SocialLink href="https://youtube.com/" label="YouTube" icon={<YoutubeIcon />} />
                    <SocialLink href="https://facebook.com/" label="Facebook" icon={<FacebookIcon />} />
                    <SocialLink href="https://instagram.com/" label="Instagram" icon={<InstagramIcon />} />
                    <SocialLink href="https://linkedin.com/" label="LinkedIn" icon={<LinkedinIcon />} />
                    <SocialLink href="https://github.com/" label="GitHub" icon={<GithubIcon />} />
                </div>
                <div className="hidden md:block w-[1px] h-4 bg-white/10"></div>
                <div className="flex items-center gap-2 text-xs">
                    <span>Made with passion & Next.js</span>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="orange" stroke="none"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
                </div>
            </div>
        </div>
      </div>
    </footer>
  );
}

// --- KOMPONENTY POMOCNICZE ---

// POPRAWKA: Dodano prop 'label' dla aria-label
function SocialLink({ href, icon, label }: { href: string, icon: React.ReactNode, label: string }) {
    return (
        <Link 
            href={href} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-500 hover:text-white transition-colors hover:scale-110"
            aria-label={label}
        >
            {icon}
        </Link>
    )
}

function YoutubeIcon() {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>
}
function FacebookIcon() {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
}
function InstagramIcon() {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
}
function LinkedinIcon() {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
}
function GithubIcon() {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/><path d="M9 18c-4.51 2-5-2-7-2"/></svg>
}